<div class="spelling">
    <div class="tag">{window.i18n.gettext('Spelling incorrect')}</div>
</div>

<style lang="scss">/*
* Scut, a collection of Sass utilities
* to ease and improve our implementations of common style-code patterns.
* v1.0.1
* Docs at http://davidtheclark.github.io/scut
*/
/* TODO implement tooltip arrow */
.spelling {
  height: 16px;
}
.spelling .tag {
  position: absolute;
  width: fit-content;
  padding: 6px 12px;
  transform: translateX(16px) translateY(-50%);
  border-radius: 24px;
  background-color: #122d40;
  color: #fff;
}</style>
